import styled from 'styled-components'

import { FireButton } from '@nx/fire/button'
import { FireInfoBox } from '@nx/fire/info-box'

export const StyledActionButton = styled(FireButton)`
  ${({ theme }) => theme.fontStyles.sourceSans.medium}
  text-decoration: underline;
  margin: 0;
`

export const StyledBidNowHint = styled(FireInfoBox)`
  p {
    color: ${({ theme }) => theme.colours.grey['90']};
  }
`

export const StyledActionContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

export const StyledLoginButton = styled(FireButton)`
  width: fit-content;
  text-decoration: underline;
  padding: 0;
  font-weight: 600;
`
